export default __webpack_public_path__ + "static/hospital_san_felipe-5c6b316bedcb8b512c75cd87c8970de6.webp";